module.exports = __webpack_public_path__ + "static/media/angular-icon.1a632d2b.png";